// extracted by mini-css-extract-plugin
module.exports = {"signup-form":"SignUp_signup-form__3UI5r"};